import React from 'react';

const ExpandRow = ({expanded, item, options, onExpand}) => {

    const expandControl = () => {
        if (!expanded) {
            if (options.customExpandControl) {
                return options.customExpandControl(onExpand, item);
            } else {
                return <i onClick={() => onExpand()} className="fas fa-chevron-down"></i>;
            }
        } else {
            if (options.customMinimizeControl) {
                return options.customMinimizeControl(onExpand, item);
            } else return <i onClick={() => onExpand()} className="fas fa-chevron-up"></i>;
        }
    }
    return <>{expandControl()}</>
}

export default ExpandRow;